// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31W_r","footer":"styles_footer__2WaOY"};